<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>
    </section>

    <section class="sucursales sucursalesinterior">
      <div class="">
        <div class="row d-flex justify-content-end align-items-end">
          <div
            class="col-lg-6 pb-lg-5"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <p>
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/headers/H_directorio.png"
                alt="Sucursales"
              />
            </p>
            <p
              class="fXG azuloscuro bold pb-lg-3 ls-1 text-center text-lg-left px-5 d-none d-md-block"
            >
              ¡Encuentra tu <br class="d-none d-xl-block" />
              sucursal de Arréglalo <br class="d-none d-xl-block" />más cercana!
            </p>
            <p
              class="fXG blanco bold pb-lg-3 ls-1 text-center text-lg-left px-5 d-block d-md-none"
            >
              ¡Encuentra tu <br class="d-none d-xl-block" />
              sucursal de Arréglalo <br class="d-none d-xl-block" />más cercana!
            </p>
          </div>

          <div
            class="col-lg-6 px-5 pb-4 pb-lg-5"
            data-aos="fade"
            data-aos-delay="400"
          >
            <form
              class="pb-lg-5"
              action="post"
              @submit="changeSucursal($event)"
            >
              <label>
                <select
                  v-model="sucursalesForm.estado"
                  @change="changeSucursal($event)"
                >
                  <option value="">Buscar por Estado</option>
                  <option name="estado" value="Campeche">Campeche</option>
                  <option name="estado" value="CDMX Centro">CDMX Centro</option>
                  <option name="estado" value="CDMX Oriente">
                    CDMX Oriente
                  </option>
                  <option name="estado" value="CDMX Poniente">
                    CDMX Poniente
                  </option>
                  <option name="estado" value="CDMX Sur">CDMX Sur</option>
                  <option name="estado" value="Chiapas">Chiapas</option>
                  <option name="estado" value="Chihuahua">Chihuahua</option>
                  <option name="estado" value="Coahuila">Coahuila</option>
                  <option name="estado" value="Edo. de México">
                    Edo. de México
                  </option>
                  <option name="estado" value="Guanajuato">Guanajuato</option>
                  <option name="estado" value="Jalisco">Jalisco</option>
                  <option name="estado" value="Querétaro">Querétaro</option>
                  <option name="estado" value="Quintana Roo">
                    Quintana Roo
                  </option>
                  <option name="estado" value="Tabasco">Tabasco</option>
                  <option name="estado" value="Tamaulipas">Tamaulipas</option>
                  <option name="estado" value="Veracruz">Veracruz</option>
                  <option name="estado" value="Yucatán">Yucatán</option>
                  <option name="estado" value="Zacatecas">Zacatecas</option>
                </select>
              </label>
              <!-- <label>
                <input
                  type="text"
                  v-model="sucursalesForm.cp"
                  @change="changeSucursal($event)"
                  @keyup="changeSucursal($event)"
                  placeholder="Buscar por Código Postal"
                />
              </label> -->

              <!-- <label>
                <button type="submit" class="btnbuscar">
                  Buscar
                </button>
              </label> -->
            </form>
          </div>
        </div>
      </div>
    </section>

    <section v-if="arr.length > 0">
      <div class="container">
        <div class="row py-5">
          <div
            class="col-12"
            v-for="sucursal in arr"
            :key="sucursal.id"
          >
            <div class="row pb-4">
              <div class="col-lg-4 col-md-5">
                <img
                  class="img-fluid pb-3"
                  :src="'/uploads/business/' + sucursal.image_name"
                  :alt="sucursal.name"
                />
              </div>
              <div class="col-lg-8 col-md-7 pb-5">
                <div class="row">
                  <div v-if="sucursal.googlemaps != ''">
                    <a
                      :href="sucursal.googlemaps"
                      target="_blank"
                      class="d-block pb-3"
                    >
                      <span
                        class="col-12 azulclaro fG underlined bold"
                        v-html="sucursal.name"
                      ></span>
                    </a>
                  </div>
                  <div v-else>
                    <span
                      class="col-12 azulclaro fG bold pb-3"
                      v-html="sucursal.name"
                    ></span>
                  </div>

                  <div class="col-12 azuloscuro fC bold">Dirección</div>
                  <div class="col-12 azuloscuro fC pb-3">
                    {{ sucursal.direccion }}
                    <br v-if="sucursal.cp != ''" />
                    <span
                      v-if="sucursal.cp != ''"
                      class="azuloscuro fC"
                      v-html="'C.P. ' + sucursal.cp"
                    ></span>
                  </div>

                  <div class="col-12 azuloscuro fC bold">Horarios</div>
                  <div
                    class="col-12 azuloscuro fC pb-4"
                    v-html="sucursal.horarios"
                  ></div>

                  <div class="col-6">
                    <div
                      class="row no-gutters d-flex justify-content-center align-items-center"
                    >
                      <div class="col-4">
                        <div class="row">
                          <div class="col-12 text-center">
                            <img
                              class="img-fluid px-1 px-md-0"
                              src="../assets/imgs/arreglalo/icons/telefono.png"
                              alt="Teléfono"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-8">
                        <div
                          class="row d-flex justify-content-center align-items-center"
                        >
                          <div class="col-12 azuloscuro fC bold pt-2">
                            Contacto
                          </div>
                          <div
                            v-if="sucursal.telefono1 != ''"
                            class="col-12 azuloscuro fC pb-3"
                          >
                            <span class="bold">T.</span>&nbsp;
                            <a
                              class="bold"
                              :href="'tel:' + sucursal.telefono1"
                              >{{ sucursal.telefono1 }}</a
                            >
                          </div>
                          <div
                            v-if="sucursal.telefono2 != ''"
                            class="col-12 azuloscuro fC pb-3"
                          >
                            <span class="bold">T.</span>&nbsp;
                            <a
                              class="bold"
                              :href="'tel:' + sucursal.telefono2"
                              >{{ sucursal.telefono2 }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row" v-if="sucursal.googlemaps != ''">
                      <div class="col-12 d-flex pb-2">
                        <!-- <div>
                          <img
                            v-for="(estrella, index) in sucursal.stars_rounded"
                            :key="index"
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star.png"
                            alt="ranking"
                          />
                          <img
                            v-for="(
                              estrella, index
                            ) in sucursal.stars_faltantes"
                            :key="index"
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star-vacio.png"
                            alt="ranking"
                          />
                        </div> -->
                        <div>
                          <img
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star.png"
                            alt="ranking"
                          />
                          <img
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star.png"
                            alt="ranking"
                          />
                          <img
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star.png"
                            alt="ranking"
                          />
                          <img
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star.png"
                            alt="ranking"
                          />
                          <img
                            width="16"
                            class="img-fluid mr-1"
                            src="../assets/imgs/arreglalo/star-vacio.png"
                            alt="ranking"
                          />
                        </div>
                      </div>
                      <div class="col-12 azulclaro fC">
                        <div class="bold">
                          ¿Te gustó el servicio de esta sucursal?
                        </div>
                        <div>
                          <a
                            class="underlined"
                            target="_blank"
                            :href="sucursal.googlemaps"
                            >Califícanos en Google</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="overflow-auto">
            <b-pagination-nav
              v-model="page"
              :link-gen="linkGen"
              :number-of-pages="computedNumberOfPages"
              use-router
            ></b-pagination-nav>
          </div>

          <div class="col-12 text-center pt-5">
            <div
              class="naranja fG underlined bold pointer"
              @click="nuevaBusqueda()"
            >
              NUEVA BÚSQUEDA
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>

    <div class="overlay" v-if="$store.state.overlay == true">
      <div class="overlaybg" @click="toggleOverlay()"></div>
      <div class="overlay-contenido">
        <div class="container">
          <div class="row">
            <div class="col-12 rounded shadow py-4 contbtn bgazul">
              <div class="btncerrar" @click="toggleOverlay()">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  />
                </svg>
              </div>

              <div class="row">
                <div class="col-12 text-center fG2 blanco bold pb-4">
                  Déjanos tus datos y en breve nos podremos en contacto.
                </div>

                <div class="col-10 offset-1 blanco">
                  <form @submit="submitFormulario($event)">
                    <label>
                      <span>Tu nombre:</span>
                      <input
                        type="text"
                        v-model="signupForm.nombre"
                        placeholder="Tu nombre"
                        required
                      />
                    </label>
                    <label>
                      <span>Tu correo electrónico:</span>
                      <input
                        type="email"
                        v-model="signupForm.email"
                        placeholder="Tu correo electrónico"
                        required
                      />
                    </label>
                    <label>
                      <span>Tu teléfono:</span>
                      <input
                        type="tel"
                        pattern="[0-9]{10}"
                        title="Introduce un teléfono válido."
                        v-model="signupForm.telefono"
                        placeholder="Tu teléfono"
                        required
                      />
                    </label>

                    <label class="text-center">
                      <button type="submit" class="btnblanco d-inline-block">
                        ENVIAR
                      </button>
                    </label>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        email: "",
        telefono: "",
      },
      sucursalesForm: {
        estado: "",
        cp: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
      datos: [],
      searchKey: "",
      currentPage: 0,
      resultCount: 0,
      pageArr: [],
      current: 0,
      arr: [],
      numberOfPages: 0,
      page: 1,
      itemsPerPage: 10,
      totalItems: 0, 
    };
  },
  name: 'Sucursales',
  metaInfo: {
    title: 'Sucursales | Arréglalo', // Sets the page title
    meta: [
      {
        name: 'description',
        content: '¡Encuentra tu sucursal de Arréglalo más cercana!',
      },
    ],
  },
  mounted: function () {
    AOS.init({
      offset: -100, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    // this.id = this.$route.params.id;
    console.log("page: " + this.$route.query.page);
    if (this.$route.query.page != undefined) {
      this.page = this.$route.query.page;
    }
    this.traeSucursales();
  },
  watch: {
    $route(to, from) {
      console.log("Page from route: ", this.$route.query.page);
      if (this.$route.query.page !== undefined) {
        this.page = Number(this.$route.query.page); // Convert to number
      } else {
        this.page = 1; // Default to page 1
      }
      this.traeSucursales();
    },
    page(newPage) {
      this.traeSucursales(); // Fetch data whenever the page changes
    },
  },

  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = this.page * this.itemsPerPage;
      const slicedItems = this.arr.slice(start, end);
      console.log({
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        start,
        end,
        slicedItems,
      });
      return slicedItems;
    },
    computedNumberOfPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage); // Calculate total pages
    }
  },
  methods: {
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    setPage: function (pageNumber) {
      this.currentPage = pageNumber;
    },
    nuevaBusqueda() {
      window.scrollTo(0, 0);
    },
    changeSucursal(e = null) {
      try {
        e.preventDefault();
      } catch (err) {
        //
      }

      if (this.page != 1) {
        this.$router.push("/sucursales?page=1");
      }

      //consulta
      let thes = this;
      this.$store.dispatch("showLoader", true);
      console.log("change estado");
      const https = require("https");
      var qData = {
        estado: this.sucursalesForm.estado,
        cp: this.sucursalesForm.cp,
        page: this.page,
        items_per_page: this.itemsPerPage,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "change-estado.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              //this.datos = res.datos;
              this.arr = res.datos;
              this.totalItems = res.total_items;
              this.numberOfPages = Math.ceil(
                res.total_items / this.itemsPerPage
              );
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    traeSucursales(e = null) {
      try {
        e.preventDefault();
      } catch (err) {
        // Handle potential error here
      }

      // Show loader
      this.$store.dispatch("showLoader", true);
      console.log("change estado");

      const https = require("https");

      // Prepare request data
      var qData = {
        estado: this.sucursalesForm.estado,
        cp: this.sucursalesForm.cp,
        page: this.page,
        items_per_page: this.itemsPerPage,
      };

      // Make API request
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "change-estado.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // Hide loader
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              // Update data
              this.arr = res.datos;
              this.totalItems = res.total_items;
              // Calculate number of pages
              this.numberOfPages = Math.ceil(res.total_items / this.itemsPerPage);
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // Handle error
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },

    changeCP() {},
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    submitFormulario(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.toggleOverlay();

              this.signupForm = {
                nombre: "",
                email: "",
                telefono: "",
              };

              swal.fire("Datos registrados", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({ click: this.$store.state.overlay });
    },
  },
  filters: {
    paginate(list) {
      const index = (this.page - 1) * this.itemsPerPage; // Calculate start index
      console.log({
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        totalItems: list.length,
        startIndex: index,
        endIndex: index + this.itemsPerPage,
      });

      // Slice the list based on the page
      return list.slice(index, index + this.itemsPerPage);
    },
  },
};


</script>


